import axios from "axios";
import { IBillingReport } from "dataModels/b2b";
import { CONGUAGLIO, DOWNLOAD_DOCUMENT, GET_VALUE_TAKEORPAY, PREBILLING_REPORT } from "shared/constants";

const HOST = window&&window._env_?window._env_.REACT_APP_HOST_PRE_BILLING:process.env.REACT_APP_HOST_PRE_BILLING;
const MODULE: string = "/pre-billing";

export const getPreBillingReport = (startDate:string,endDate:string,businessId?:string,contractId?:string) => {
    let queryString = '?startDate='+startDate+'&endDate='+endDate;
    if(businessId!==''){queryString=queryString+'&businessId='+businessId}
    if(contractId!==''){queryString=queryString+'&contractId='+contractId}
    return axios.get(HOST+MODULE+PREBILLING_REPORT+queryString,{params:{}})
    .then(response=>{
        return response.data;
    });
}

export const postPreBillingReport = (type:string,formData:IBillingReport) => {
    let queryString = "?action="+type
    return axios.post(HOST + MODULE + PREBILLING_REPORT+queryString, formData)
    .then(response => {
        return response;
    })
}

export const getConguaglioAPI = (contractId:string) => {
    return axios.get(HOST+MODULE+CONGUAGLIO,{params: { contractId: contractId } })
    .then(response=>{
        return response.data;
    });
}


export const postConguaglioAPI = (contractId:string, adjustment:number) => {
    return axios.post(HOST+MODULE+CONGUAGLIO, { contractId: contractId, adjustment: adjustment })
    .then(response=>{
        return response.data; 
    });
}



export const downloadDocument = (type:string,startDate:string,endDate:string,businessId?:string,contractId?:string) => {
    let queryString = "/"+type+"?startDate="+startDate+'&endDate='+endDate;
    if(businessId){queryString=queryString+'&businessId='+businessId}
    if(contractId){queryString=queryString+'&contractId='+contractId}
    return axios.get(HOST + MODULE + DOWNLOAD_DOCUMENT+queryString, { responseType: "blob" });
}

export const getValueToP= (contractId?:string) => {
    let queryString = '?contractId='+contractId
    return axios.get(HOST+MODULE+GET_VALUE_TAKEORPAY+queryString,{params:{}})
    .then(response=>{
        return response.data;
    });
}